import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Button, Group, Text, Textarea, Skeleton, Flex } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import TestsApi from "../../api/TestsApi";
import { HelpTip } from "../../components/GeneralComponent/GeneralComponent";

export function TestCompletedWinner({ selectedMemberWebsite, pageId, openWinnerModal, setWinnerModalOpen, setWinnerCloseModal, systemUsageLoader, setMakeApiCall, setSelectedThumbnail }:any) {
  const navigate = useNavigate();
  const [setWinnerData, setSetWinnerData] = useState([]);
  const [loading, setloading] = useState(false);
  const [discardedByCronId, setDiscardedByCronId] = useState('');

  useEffect(() => {
    if (openWinnerModal) {
      setloading(true);
      TestsApi.setwinnerpopupget({
        page_id: pageId,
        test_id: 0,
        winner_type: 'test-completed'
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate('/logout');
          }
        }
      })
      .then((data) => {
        if (data.status === 1) {
          setDiscardedByCronId(data.data.discarded_by_cron);
          setSetWinnerData(data.data.set_winner_data);
          setWinnerModalOpen(true);
          setloading(false);
        }
      })
      .catch((error) => {
        console.error('API Error:', error);
        setloading(false);
      });
    }
  }, [openWinnerModal]);

  const handleSetWinner = () => {
    systemUsageLoader(true);
    TestsApi.discardbycron({
      system_website_id: selectedMemberWebsite,
      discarded_by_cron: discardedByCronId,
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate('/logout');
        }
      }
    })
    .then((data) => {
      if (data.status === 1) {        
        systemUsageLoader(false);
        setWinnerCloseModal();    
        setMakeApiCall(true);    
        setSelectedThumbnail(null);
        navigate('/review-tests');
      }else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        systemUsageLoader(false);
      }
    })
    .catch((error) => {
      console.error('API Error:', error);
      systemUsageLoader(false);
    });
  }


  return (
    <>
      <Modal.Root opened={openWinnerModal} onClose={setWinnerCloseModal} size="80%" trapFocus = {false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>
              SET WINNER <HelpTip helpId={189} />
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <Text weight={500} fz={14}>CONGRATULATIONS, YOU HAVE A WINNER!</Text>
            <Text mt={12} fz={14}>
              To ensure only the winning versions of the variables will show for your visitors in the future you have two choices:
            </Text>
            <Text mt={12} fz={14}>
              <Text fz={14} >1. Do nothing, simply leave the Visiopt test script on your page, and we will make sure only the winning versions show to visitors</Text>
              <Text fz={14} mt={12}>2. You can manually update the winning versions of the variables on your page. For your convenience we display the code that must be changed on your page in the table below.
                <Text fz={14}>To use this option, please update your page and then stop the test.</Text>
                <Text fz={14}>(To update the source code of your page to the winning versions of the variables you have to search for the text/code of the control versions of each variable and replace it with the text/code of the corresponding winning versions.)</Text>
              </Text>
            </Text>
            <form>
                {setWinnerData.map((item,index) => (
                  <>
                  <Text fz={14} mt={15} weight={500}>Variable: {item.variable_title}</Text>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                    <div style={{ flex: 1, marginRight: 10 }}>
                      <Text fz={14}>Control Version: {item.control_title}</Text>
                      {loading ? (
                        <Flex justify="space-between" gap="sm" mt={10}>
                          <Skeleton height={130} width={500} />
                        </Flex>
                      ) : (
                      <Textarea
                        value={item.control_content}
                        minRows={5}
                        readOnly
                      />
                      )}
                    </div>
                    <div style={{ flex: 1, marginLeft: 10 }}>
                      <Text fz={14} ml={10}>Winner Version: {item.ver_title}</Text>
                      {loading ? (
                        <Flex justify="space-between" gap="sm" mt={10}>
                          <Skeleton height={130} width={500} />
                        </Flex>
                      ) : (
                      <Textarea
                        value={item.ver_content}
                        minRows={5}
                        readOnly
                      />
                      )}
                    </div>
                  </div>
                  </>
                ))}
              <Group position="right">
                <Button type="button" size="sm" w={100} mt={10} mb={10} onClick={handleSetWinner}>
                  Continue
                </Button>
              </Group>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}